import { AsyncThunk } from '@reduxjs/toolkit';
import { getWaitingOrders } from 'entities/orders';
import { OrderWaitingList } from 'features/orders/orderWaitingList';
import { PaginationFilterProvider } from 'shared/ui/pagination';
import { DashboardContainer } from 'widgets/dashboardContainer';
import { OrderDashboard } from 'widgets/orderDashboard';
import { WaitingOrdersFilterPanel } from 'widgets/waitingOrdersFilterPanel';

export const WaitingList = () => {
	return (
		<PaginationFilterProvider
			fetchData={getWaitingOrders as AsyncThunk<any, any, any>}
		>
			<DashboardContainer>
				<WaitingOrdersFilterPanel />
				<OrderDashboard
					goToBooking={true}
					placeholder="Нажмите на карточку, которая вас интересует,
						чтобы вы смогли увидеть более полную информацию о бронировании"
					orderDetailInfoTitle={'Детали заявки'}
					updateOrderInPersonModal={'waitingOrders'}
					newApplicationBtn={true}
				>
					<OrderWaitingList />
				</OrderDashboard>
			</DashboardContainer>
		</PaginationFilterProvider>
	);
};
